export const ShoeSizeGuideType = {
  women: 'women',
  men: 'men',
  kids: 'kids',
};

const WIDTH_COLUMNS = ['length', 'narrow', 'average', 'wide', 'eu', 'uk', 'us'];
const KIDS_COLUMNS = ['kidsLength', 'eu', 'uk', 'us'];

export const SizeGuides = {
  [ShoeSizeGuideType.women]: {
    caption: 'sizeGuide.caption.women',
    variant: 'width',
    columns: WIDTH_COLUMNS,
    rows: [
      ['218-222', '218', '220', '221', '36', '3', '5'],
      ['222-226', '221', '223', '225', '36.5', '3.5', '5.5'],
      ['226-231', '225', '226', '228', '37', '4', '6'],
      ['231-235', '228', '230', '231', '37.5', '4.5', '6.5'],
      ['235-239', '231', '233', '235', '38', '5', '7'],
      ['240-244', '235', '237', '238', '38.5', '5.5', '7.5'],
      ['244-248', '238', '240', '242', '39', '6', '8'],
      ['248-252', '242', '243', '245', '40', '6.5', '8.5'],
      ['252-256', '245', '246', '248', '41', '7', '9'],
      ['256-260', '248', '250', '251', '41.5', '7.5', '9.5'],
      ['260-264', '251', '253', '255', '42', '8', '10'],
      ['264-268', '255', '256', '258', '42.5', '8.5', '10.5'],
      ['268-272', '258', '260', '262', '43', '9', '11'],
    ],
  },
  [ShoeSizeGuideType.men]: {
    caption: 'sizeGuide.caption.men',
    variant: 'width',
    columns: WIDTH_COLUMNS,
    rows: [
      ['252-256', '249', '251', '252', '41', '7', '8'],
      ['256-260', '252', '254', '255', '41.5', '7.5', '8.5'],
      ['260-264', '255', '256', '257', '42', '8', '9'],
      ['264-269', '257', '259', '260', '42.5', '8.5', '9.5'],
      ['269-273', '260', '261', '262', '43', '9', '10'],
      ['273-277', '262', '263', '264', '43.5', '9.5', '10.5'],
      ['277-281', '264', '265', '267', '44', '10', '11'],
      ['281-286', '267', '268', '269', '44.5', '10.5', '11.5'],
      ['286-290', '269', '271', '272', '45', '11', '12'],
      ['290-294', '272', '273', '274', '46', '11.5', '12.5'],
      ['294-298', '274', '275', '276', '47', '12', '13'],
    ],
  },
  [ShoeSizeGuideType.kids]: {
    caption: 'sizeGuide.caption.kids',
    variant: 'simple',
    columns: KIDS_COLUMNS,
    rows: [
      ['135-141', '23', '6', '7C'],
      ['143-149', '24', '7', '8C'],
      ['150-156', '25', '8', '9C'],
      ['158-164', '27', '9', '10C'],
      ['166-172', '28', '10', '11C'],
      ['173-179', '30', '11', '12C'],
      ['181-187', '31', '12', '13C'],
      ['189-195', '32', '13', '1Y'],
      ['197-203', '33', '1', '2Y'],
      ['206-212', '34', '2', '3Y'],
    ],
  },
};
